import React from "react";
import {useTravianServerContext} from "../../../react/providers/travianServerProvider";

export default function ToolTrav25() {
    const data = useTravianServerContext();

    return <div>
        {JSON.stringify(data)}
    </div>
}
